import script from "./AddGeneralNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGeneralNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./AddGeneralNoteModal.vue?vue&type=style&index=0&id=8d9ded62&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d9ded62"]])

export default __exports__